import Layout from '@/layout';
var distributorRouter = {
  path: '/distributor',
  component: Layout,
  redirect: '/distributor/setting',
  name: 'Distributor',
  alwaysShow: true,
  meta: {
    title: '经销商管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'setting',
    component: function component() {
      return import('@/views/distributor/setting/index');
    },
    name: 'DistributorSetting',
    meta: {
      title: '基础设置'
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/distributor/level/index');
    },
    name: 'DistributorLevel',
    meta: {
      title: '等级管理'
    }
  }, {
    path: 'member',
    component: function component() {
      return import('@/views/distributor/member/index');
    },
    name: 'DistributorMember',
    meta: {
      title: '经销商成员'
    }
  }, {
    path: 'reward',
    component: function component() {
      return import('@/views/distributor/reward/index');
    },
    name: 'DistributorReward',
    meta: {
      title: '奖励明细'
    }
  }]
};
export default distributorRouter;